/*
    Let a;
    let b;
    let c;
    let e;
    let f;
    let g;
    let h;
    let i;
*/

// A = window.deviceAdvFreq;
// C = window.document.documentElement;
const userAgent = window.navigator.userAgent.toLowerCase();

const deviceAdvFreq = {
    ios() {
        return this.iphone() || this.ipod() || this.ipad();
    },

    iphone() {
        return userAgent.includes('iphone');
    },

    ipod() {
        return userAgent.includes('ipod');
    },

    ipad() {
        return userAgent.includes('ipad');
    },

    android() {
        return userAgent.includes('android');
    },

    androidPhone() {
        return this.android() && userAgent.includes('mobile');
    },

    androidTablet() {
        return this.android() && !userAgent.includes('mobile');
    },

    blackberry() {
        return userAgent.includes('blackberry') || userAgent.includes('bb10') || userAgent.includes('rim');
    },

    blackberryPhone() {
        return this.blackberry() && !userAgent.includes('tablet');
    },

    blackberryTablet() {
        return this.blackberry() && userAgent.includes('tablet');
    },

    windows() {
        return userAgent.includes('windows');
    },

    windowsPhone() {
        return this.windows() && userAgent.includes('phone');
    },

    windowsTablet() {
        return this.windows() && userAgent.includes('touch');
    },

    fxos() {
        return (userAgent.includes('(mobile;') || userAgent.includes('(tablet;')) && userAgent.includes('; rv:');
    },

    fxosPhone() {
        return this.fxos() && userAgent.includes('mobile');
    },

    fxosTablet() {
        return this.fxos() && userAgent.includes('tablet');
    },

    meego() {
        return userAgent.includes('meego');
    },

    mobile() {
        return (
            this.androidPhone() || this.iphone() || this.ipod() || this.windowsPhone() || this.blackberryPhone() || this.fxosPhone() || this.meego()
        );
    },

    tablet() {
        return this.ipad() || this.androidTablet() || this.blackberryTablet() || this.windowsTablet() || this.fxosTablet();
    },

    portrait() {
        return Math.abs(window.orientation) !== 90;
    },

    landscape() {
        return Math.abs(window.orientation) === 90;
    },

    /*
    
        DeviceAdvFreq.noConflict = function () {
            window.deviceAdvFreq = a;
            return this;
        };
    
    
        f = function (a) {
            let b;
            b = new RegExp(a, 'i');
            return c.className.match(b);
        };
    
        b = function (a) {
            if (!f(a)) {
                c.className += ' ' + a;
            }
        };
    
        h = function (a) {
            if (f(a)) {
                c.className = c.className.replace(a, '');
            }
        };
        
    
        if (deviceAdvFreq.ios()) {
            if (deviceAdvFreq.ipad()) {
                b('ios ipad tablet');
            } else if (deviceAdvFreq.iphone()) {
                b('ios iphone mobile');
            } else if (deviceAdvFreq.ipod()) {
                b('ios ipod mobile');
            }
        } else if (deviceAdvFreq.android()) {
            if (deviceAdvFreq.androidTablet()) {
                b('android tablet');
            } else {
                b('android mobile');
            }
        } else if (deviceAdvFreq.blackberry()) {
            if (deviceAdvFreq.blackberryTablet()) {
                b('blackberry tablet');
            } else {
                b('blackberry mobile');
            }
        } else if (deviceAdvFreq.windows()) {
            if (deviceAdvFreq.windowsTablet()) {
                b('windows tablet');
            } else if (deviceAdvFreq.windowsPhone()) {
                b('windows mobile');
            } else {
                b('desktop');
            }
        } else if (deviceAdvFreq.fxos()) {
            if (deviceAdvFreq.fxosTablet()) {
                b('fxos tablet');
            } else {
                b('fxos mobile');
            }
        } else if (deviceAdvFreq.meego()) {
            b('meego mobile');
        } else {
            b('desktop');
        }
    
        e = function () {
            if (deviceAdvFreq.landscape()) {
                h('portrait');
                b('landscape');
            } else {
                h('landscape');
                b('portrait');
            }
        };
    
        i = 'onorientationchange' in window;
        g = i ? 'orientationchange' : 'resize';
        if (window.addEventListener) {
            window.addEventListener(g, e, !1);
        } else if (window.attachEvent) {
            window.attachEvent(g, e);
        } else {
            window[g] = e;
        }
    
        e();
        */
};

window.deviceAdvFreq = deviceAdvFreq;

export default deviceAdvFreq;
